export default __webpack_public_path__ + "static/media/mnm-exports-thumb.23fa9aad.png";